import React from 'react';
import PropTypes from 'prop-types';
import {
  FDBodyText, FDDisplayText, FDStack, FDTitleText,
} from '@facet-wealth/design';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { MediaRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/MediaRel';
import fr from 'facet-rest';
import MetaControl from 'Components/UI/Meta/MetaControl';
import {
  BodyTextMedium, DisplayTextLarge, TitleTextMedium,
} from 'Packages/FacetDesign/Components';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';
import { dataAttrs } from 'Helpers/Testing';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => DisplayTextLarge,
    _customProps: { align: 'center' },
  }, overrideReadOnly)
  .override({ name: 'title', hint: 'richtext' }, {
    _component: () => Richtext,
    _customProps: { Component: FDDisplayText, size: 'lg', align: 'center' },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => TitleTextMedium,
    _customProps: { align: 'center' },
  }, overrideReadOnly)
  .override({ name: 'subtitle', hint: 'richtext' }, {
    _component: () => Richtext,
    _customProps: { Component: FDTitleText, size: 'md', align: 'center' },
  }, overrideReadOnly)
  .nameOverride('description', {
    _component: () => BodyTextMedium,
    _customProps: { align: 'center' },
  }, overrideReadOnly)
  .override({ name: 'description', hint: 'richtext' }, {
    _component: () => Richtext,
    _customProps: { Component: FDBodyText, size: 'md', align: 'center' },
  }, overrideReadOnly);

export const Hero = ({ structuredContentResource }) => {
  return (
    <FDStack
      direction={'column'}
      alignItems={'center'}
      spacing={4}
      {...dataAttrs('structured-content-hero', structuredContentResource)}
    >
      <MediaRel
        relationship={structuredContentResource.relationship(fr.relationships.media.name)}
        {...dataAttrs('structured-content-hero-media', structuredContentResource)}
      />
      <MetaControl
        resource={structuredContentResource}
        attrName={'title'}
        metaOverrideSet={metaOverrideSet}
        CustomProps={{
          ...dataAttrs('structured-content-hero-title', structuredContentResource),
          align: 'center',
        }}
      />
      <MetaControl
        resource={structuredContentResource}
        attrName={'subtitle'}
        metaOverrideSet={metaOverrideSet}
        CustomProps={{
          ...dataAttrs('structured-content-hero-subtitle', structuredContentResource),
          align: 'center',
        }}
      />
      <MetaControl
        resource={structuredContentResource}
        attrName={'description'}
        metaOverrideSet={metaOverrideSet}
        CustomProps={{
          ...dataAttrs('structured-content-hero-description', structuredContentResource),
          align: 'center',
        }}
      />
    </FDStack>
  );
};

Hero.propTypes = {
  structuredContentResource: PropTypes.object.isRequired,
};
